export enum VideoEmailStatus {
  NoStatus = '',
  NotSent = 'not_sent',
  Sent = 'sent',
  Watched = 'watched',
  Deleted = 'deleted',
}
